'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var WebFont = require('webfontloader');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var WebFont__default = /*#__PURE__*/_interopDefaultLegacy(WebFont);

const useFonts = fonts => {
  const [loaded, setLoaded] = react.useState(false);
  const families = Object.keys(fonts).reduce((allFamilies, type) => {
    const {
      families: typeFamilies = [],
      id = null
    } = fonts[type];
    return [...allFamilies, ...typeFamilies, id];
  }, []).filter(it => it !== null).sort().join(',');
  react.useEffect(() => {
    let canceled = false;
    const onFontsActive = () => {
      if (!canceled) {
        setLoaded(true);
      }
    };
    WebFont__default["default"].load({
      ...fonts,
      active: onFontsActive
    });
    return () => {
      canceled = true;
    };
  }, [families]);
  return {
    loaded
  };
};

exports.useFonts = useFonts;
